const sticky = () => {
    const stickyEngage = () => {
        //  begin sticky when user scrolls to top of element
        // if ($(window).scrollTop() > 0) {
        if (($(window).scrollTop() + $('body').offset().top) > ($('.sticky-wrapper').prev().offset().top + $('.sticky-wrapper').prev().height())) {
            const gracefulStickyHeight = $('.sticky-wrapper').height();
            $('.sticky-wrapper').addClass('stuck');
            $('.sticky-wrapper').prev().css('marginBottom', gracefulStickyHeight);
        }
        else {
            $('.sticky-wrapper').removeClass('stuck');
            $('.sticky-wrapper').prev().css('marginBottom', 0);
        }
    }


    if ($('.sticky-wrapper').length) {
        $(window).scroll(function() {
            stickyEngage();
        });
    }
};